import { useEffect } from 'react';

import TokenManager from '@viome/viome-base/src/api/TokenManager';
import { LocalStorage } from '@/utils/LocalStorage';
import EventTracker from '@utils/EventTracker';

const useInitialization = () => {
  useEffect(() => {
    const storageProvider = {
      set: (key: string, value: string) => LocalStorage.setItem(key, value),
      getString: (key: string) => LocalStorage.getItem(key) || null,
      delete: (key: string) => LocalStorage.removeItem(key),
    };
    EventTracker.initialize();
    TokenManager.setStorageProvider(storageProvider);
    TokenManager.setClientVersion('7.2.0');
    TokenManager.setClientType('Web');
  }, []);
};

export default useInitialization;